import * as React from "react";
import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';

@observer
export default class PrivateRoute extends React.Component<any> {

	render() {
		if (window.localStorage.getItem('jwt')) 
			return <Route {...this.props} />;
		return <Redirect to="/login" />;
	}
}